import { useCallback, useEffect, useState } from "react";
import { Explain, NotAvailable } from "@/components/area/Explain";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { errMsg, formatDate, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { can } from "@/components/crm/helpers";
import { DomainCard } from "./DomainCard";

// «Domini ed email»: preparatory wizard (read-only DNS checks). Nothing is changed and nothing is declared connected.
export default function AreaDomains({ tid, role, go }) {
  const api = useApi();
  const [d, setD] = useState(null);
  const [dom, setDom] = useState("");
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get(`/t/${tid}/domain-setup`).then(({ data }) => setD(data)).catch((e) => toast.error(errMsg(e))), [api, tid]);
  useEffect(() => { load(); }, [load]);
  if (!d) return <Loader2 className="animate-spin text-slate-400" />;
  const add = async () => {
    setBusy(true);
    try { await api.post(`/t/${tid}/domain-setup`, { domain: dom }); setDom(""); toast.success("Dominio controllato"); load(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const help = () => go("support", { type: "question", title: "Non so dove gestisco il mio dominio", text: `Il mio dominio è ${dom || "…"}. Non so chi gestisce i DNS: mi aiutate?` });
  return (
    <div className="space-y-3" data-testid="area-domains">
      <NotAvailable title="Collegamento del dominio al sito" text="Per ora puoi verificare il tuo dominio. Il collegamento al sito lo attiva MUSORA quando sarà disponibile." testid="domains-not-available" />
      <Explain testid="domains-explain"><p data-testid="domains-prep-note">{d.note} Facciamo solo controlli in lettura: i tuoi DNS e la tua posta non vengono toccati.</p></Explain>
      {d.can_manage ? <section className="space-y-2 rounded-lg border border-slate-200 bg-white p-4">
        <p className="text-sm font-medium text-slate-800">1. Qual è il tuo dominio?</p>
        <div className="flex flex-wrap gap-2"><Input value={dom} onChange={(e) => setDom(e.target.value)} placeholder="tuodominio.it" className="h-10 w-64" data-testid="domain-input" />
          <Button className="h-10" disabled={busy || dom.trim().length < 3} onClick={add} data-testid="domain-add">{busy && <Loader2 size={15} className="mr-1.5 animate-spin" />}Controlla</Button></div>
        <Button variant="link" className="h-auto p-0 text-xs" onClick={help} data-testid="domain-help">Non so dove gestisco il dominio</Button>
      </section> : <p className="text-xs text-slate-500" data-testid="domains-readonly">Il tuo ruolo può vedere lo stato dei domini, non aggiungerli.</p>}
      {d.domains.map((x) => <DomainCard key={x.id} tid={tid} d={x} canManage={d.can_manage} onChange={load} onHelp={help} />)}
      {d.domains.length === 0 && <p className="text-sm text-slate-500" data-testid="domains-empty">Nessun dominio inserito.</p>}
      <p className="text-[11px] text-slate-400">Ultimo aggiornamento: {d.domains[0]?.checked_at ? formatDate(d.domains[0].checked_at, true) : "—"}</p>
    </div>);
}
